import * as React from 'react';
import { BottomSheetAnimatedWrapperProps } from './schema/BottomSheetAnimatedProps';
import { lazy, Suspense } from 'react';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () =>
        import(
            /* webpackChunkName: "MiniBottomSheetAnimated" */
            './lazyIndex'
        )
);

export const lazyShowBottomSheet = new LazyAction(lazyModule, m => m.showBottomSheet);
export const lazyHideBottomSheet = new LazyAction(lazyModule, m => m.hideBottomSheet);

const LazyBottomSheetAnimated = lazy(() => import('./components/BottomSheetAnimatedPortal'));

export const BottomSheetAnimated: React.FC<BottomSheetAnimatedWrapperProps> = React.forwardRef(
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    (props, ref?: React.RefObject<any>) => (
        <Suspense fallback={null}>
            <LazyBottomSheetAnimated {...props} ref={ref} />
        </Suspense>
    )
);

export { BottomSheetAnimatedWrapperProps };
export default BottomSheetAnimated;
